export default __webpack_public_path__ + "images/technical_err.png";